import { render, staticRenderFns } from "./RemoveInvoiceModal.vue?vue&type=template&id=55bc67b2&"
import script from "./RemoveInvoiceModal.vue?vue&type=script&lang=js&"
export * from "./RemoveInvoiceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports